
import React from 'react';
import { Heart, Shield, Activity, Code } from 'lucide-react';

export function ValuePropsSection() {
  const valueProps = [
    {
      icon: Heart,
      title: "User-Friendly",
      description: "Intuitive interface designed for teams of all technical backgrounds"
    },
    {
      icon: Activity,
      title: "Performance",
      description: "Optimized for speed and efficiency, even with high-volume data"
    },
    {
      icon: Code,
      title: "Integration",
      description: "Connects seamlessly with your existing tools and workflows"
    },
    {
      icon: Shield,
      title: "Security",
      description: "Enterprise-grade security with data encryption and compliance"
    }
  ];

  return (
    <div className="py-20 px-4 bg-background">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-6 text-foreground">
            Why choose <span className="text-yellow-400">atWork.ai?</span>
          </h2>
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
            Built with modern teams in mind, delivering the features you need to succeed
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {valueProps.map((prop, index) => (
            <div key={index} className="text-center p-8 bg-card border border-border rounded-2xl hover:bg-accent/50 transition-all duration-300 group">
              <div className="inline-flex justify-center items-center w-16 h-16 rounded-2xl bg-yellow-400/10 border border-yellow-400/20 text-yellow-400 mb-6 group-hover:bg-yellow-400/20 transition-colors">
                <prop.icon className="w-8 h-8" />
              </div>
              <h3 className="text-xl font-semibold mb-4 text-foreground">{prop.title}</h3>
              <p className="text-muted-foreground leading-relaxed">{prop.description}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
